import { sdk } from 'src/utilities/sdk';
import { IAsyncTaskResponse } from 'src/utilities/useAsyncTask';

export interface UpdateMealCreditPeoplePayload {
  diners_to_add: string[];
  diners_to_remove: string[];
}

export interface UpdateMealCreditPeopleProps {
  corpId: string;
  mealCreditId: string;
  payload: UpdateMealCreditPeoplePayload;
}

export const updateMealCreditPeople = async ({
  corpId,
  mealCreditId,
  payload,
}: UpdateMealCreditPeopleProps): Promise<IAsyncTaskResponse> => {
  return sdk.http.put(
    `/corp-admin/${corpId}/groups/v2/${mealCreditId}/diners`,
    payload
  );
};
